import { useMutation } from "@apollo/client";
import { RejectExternalSigningMutationVariables } from "gql/graphql";
import { useTranslations } from "use-intl";
import { useNotification } from "@/shared/feedback/notification";
import { REJECT_EXTERNAL_SIGNING } from "@/modules/gateway/features/open-external-sign/api/reject-external-signing";
import { useCode } from "@/modules/gateway/features/open-external-sign/model/use-code";

export function useRejectExternalSigningMutation() {
  const t = useTranslations("RejectSigning");
  const notify = useNotification();
  const { code } = useCode();

  const [rejectExternalSigning, { loading }] = useMutation(
    REJECT_EXTERNAL_SIGNING,
  );

  /** `code` — из ссылки, поэтому от формы приходит только комментарий. */
  const reject = async ({
    comment,
  }: Pick<RejectExternalSigningMutationVariables, "comment">) => {
    if (!code) {
      return false;
    }

    const trimmedComment = comment?.trim();

    try {
      // ошибку показывает глобальный провайдер; пустой комментарий не отправляем вовсе
      const response = await rejectExternalSigning({
        variables: trimmedComment
          ? { code, comment: trimmedComment }
          : { code },
      });

      if (!response.data?.rejectExternalSigning) {
        return false;
      }
    } catch {
      return false;
    }

    notify?.success({ message: t("Signing rejected") });

    return true;
  };

  return { reject, loading };
}
